export enum Env {
  Local,
  Dev,
  Prod,
}

export function currentEnv(): Env {
  switch (window._ENV) {
    case "local":
      return Env.Local;
    case "dev":
      return Env.Dev;
    case "prod":
      return Env.Prod;
    default:
      throw new Error(`Undefined environment: ${window._ENV ?? "undefined"}`);
  }
}

export function currentEnvIsDevOrLocal(): boolean {
  return currentEnv() === Env.Dev || currentEnv() === Env.Local;
}

export function isTesting(): boolean {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (globalThis as any).process?.env?.NODE_ENV === "test";
}

export function mocksResponse(): boolean {
  return currentEnv() == Env.Local && !window?._NGROK_HOST;
}

export function isIOSAppEnv(): boolean {
  const userAgent = window.navigator.userAgent.toLowerCase();
  const safari = /safari/.test(userAgent);
  const ios = /iphone|ipod|ipad/.test(userAgent);
  return ios && !safari;
}

export function getIOSVersion(): [number, number, number] {
  const userAgent = window.navigator.userAgent.toLowerCase();
  const ios = /iphone|ipod|ipad/.test(userAgent);
  if (ios) {
    const v = userAgent.match(/os (\d+)[_|.](\d+)[_|.]?(\d+)?/);
    if (v) {
      return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || "0", 10)];
    }
  }

  return [0, 0, 0];
}

function isIFrameEnv(): boolean {
  return window.parent.location !== window.parent.parent.location;
}

function isNativeAndroidAppEnv(): boolean {
  const userAgent = window.navigator.userAgent.toLowerCase();
  return /com\.classdojo\.android/.test(userAgent);
}

export function isEmbeddedEnv(): boolean {
  return isIOSAppEnv() || isIFrameEnv() || isNativeAndroidAppEnv();
}

export function isScreenshotEnv(): boolean {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const screenshot = urlSearchParams.get("screenshot");
  return screenshot != null && ["true", "", "1"].includes(screenshot);
}
